export const FETCH_STORES = 'FETCH_STORES';
export const FETCH_STORES_SUCCESS = `${FETCH_STORES}_SUCCESS`;
export const FETCH_STORES_FAIL = `${FETCH_STORES}_FAIL`;
export const vendorTypes = {
  Ecommerce: '1',
  VoucherFisico: '2',
  VoucherVirtual: '3',
  Milhas: '4',
  Outros: '5',
  RecargaDeCelular: '6',
  VoucherVirtualExterno: '7',
  Doacao: '8',
  PagueContas: '14',
  CreditoShellVPower: '15',
};

const formatStores = (vendorTypes, stores) => ({
  ecommerce: stores.filter(
    (it) => !isVendorInactive(it.statusId)
            && (!it.supplierTypeId || it.supplierTypeId === vendorTypes.Ecommerce),
  ),
  vouchers: stores.filter(
    (it) => !isVendorInactive(it.statusId)
            && (it.supplierTypeId === vendorTypes.VoucherFisico
                || it.supplierTypeId === vendorTypes.VoucherVirtual
                || it.supplierTypeId === vendorTypes.VoucherVirtualExterno),
  ),
  services: stores.filter(
    (it) => !isVendorInactive(it.statusId)
            && (it.supplierTypeId === vendorTypes.RecargaDeCelular
                || it.supplierTypeId === vendorTypes.Milhas
                || it.supplierTypeId === vendorTypes.Doacao
                || it.supplierTypeId === vendorTypes.Outros
                || it.supplierTypeId === vendorTypes.PagueContas
                || it.supplierTypeId === vendorTypes.CreditoShellVPower),
  ),
});

const statusVendorEnum = {
  ativo: 1,
  inativo: 2,
  suspenso: 3,
};

const isVendorInactive = (statusId) => !!(
  statusId === statusVendorEnum.inativo
        || statusId === statusVendorEnum.suspenso
);

const StoresReducer = (state = {
  isLoading: false,
  ecommerce: [],
  vouchers: [],
  services: [],
  error: null,
  vendorTypes,
}, action = {}) => {
  switch (action.type) {
    case FETCH_STORES:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_STORES_SUCCESS:
      return {
        ...state,
        ...formatStores(vendorTypes, action.payload.data),
        isLoading: false,
      };
    case FETCH_STORES_FAIL:
      return { ...state, isLoading: false, error: action.error };
    default:
      return state;
  }
};

export default StoresReducer;
